import { useEffect, useState } from "react";

// Shared by landing/index.tsx and sign_in/index.tsx - both have a "Continue
// with Google" button whose loading state follows the same rule: the caller
// sets it true right before calling signInWithRedirect, and the only two
// ways out are a thrown error (handled by each caller's own catch block) or
// the browser restoring this page from the back/forward cache (e.g. the
// user backs out of the Google account chooser) - bfcache freezes and
// restores the JS heap, so without this listener the flag would come back
// `true` with the button stuck disabled and no way to retry short of a
// manual reload. event.persisted is true specifically for a bfcache
// restore. Previously duplicated near-verbatim in both files; extracted so
// the two copies of this invariant can't drift from each other.
export const useGoogleSignInLoading = () => {
  const [googleSignInLoading, setGoogleSignInLoading] = useState(false);

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setGoogleSignInLoading(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  return [googleSignInLoading, setGoogleSignInLoading] as const;
};
